var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { currentAccountState, currentUserState } from '@/presentation/components';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router';
import { useRecoilValue } from 'recoil';
import Cookies from 'js-cookie';
import { KEY_COOKIE_WELCOME } from '../constants/storage-keys';
export const useLogout = () => {
    const navigate = useNavigate();
    const { setCurrentAccount } = useRecoilValue(currentAccountState);
    const { setCurrentUser } = useRecoilValue(currentUserState);
    return () => __awaiter(void 0, void 0, void 0, function* () {
        Cookies.remove(KEY_COOKIE_WELCOME);
        sessionStorage.clear();
        yield Auth.signOut();
        setCurrentAccount(undefined);
        setCurrentUser(undefined);
        navigate('/login');
    });
};
export const useSimpleLogout = () => {
    const { setCurrentAccount } = useRecoilValue(currentAccountState);
    const { setCurrentUser } = useRecoilValue(currentUserState);
    return () => __awaiter(void 0, void 0, void 0, function* () {
        Cookies.remove(KEY_COOKIE_WELCOME);
        sessionStorage.clear();
        yield Auth.signOut();
        setCurrentAccount(undefined);
        setCurrentUser(undefined);
        // This is a workaround to avoid the error "Cannot update a component (`RecoilRoot`) while rendering a different component"
        setTimeout(() => {
            sessionStorage.clear();
        }, 1000);
    });
};
